(() => {
  function setupWrap(wrap){
    if (wrap.__ccPillsReady) return;
    wrap.__ccPillsReady = true;

    const scroller = wrap.querySelector('.cc-pills-scroll');
    const prev = wrap.querySelector('.cc-pills-btn.cc-pills-prev');
    const next = wrap.querySelector('.cc-pills-btn.cc-pills-next');
    if (!scroller || !prev || !next) return;

    const step = () => Math.max(220, Math.round(scroller.clientWidth * 0.8));

    function update(){
      const atStart = scroller.scrollLeft <= 2;
      const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
      prev.classList.toggle('is-hidden', atStart);
      next.classList.toggle('is-hidden', atEnd);
    }

    // Buttons
    prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => scroller.scrollBy({ left:  step(), behavior: 'smooth' }));
    scroller.addEventListener('scroll', update, { passive: true });

    // -------- Drag to scroll (touch/pen only) ----------
    // Let the browser handle horizontal scroll gestures
    scroller.style.touchAction = 'pan-x';

    let isDown = false, startX = 0, startLeft = 0, moved = false;

    scroller.addEventListener('pointerdown', e => {
      // Do NOT hijack desktop mouse — keeps links clickable
      if (e.pointerType === 'mouse') return;

      // If the press started on an interactive element, let it click
      if (e.target.closest('a, button, input, select, textarea')) return;

      isDown = true; moved = false;
      startX = e.clientX; startLeft = scroller.scrollLeft;
      try { scroller.setPointerCapture(e.pointerId); } catch(_) {}
    });

    scroller.addEventListener('pointermove', e => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      scroller.scrollLeft = startLeft - dx;
    });

    function endDrag(e){
      if (!isDown) return;
      // If we dragged, suppress the “ghost click”
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
      isDown = false; moved = false;
      try { scroller.releasePointerCapture(e.pointerId); } catch(_) {}
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);

    // Defensive: if a click still bubbles after a drag, cancel it
    scroller.addEventListener('click', e => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    update();
    window.addEventListener('resize', update);
  }

  function init(root = document){
    root.querySelectorAll('.cc-pills').forEach(setupWrap);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
